'use client';

import { Button } from '@/components/ui/button';
import { usePlanCatalog } from '../lib/use-plan-catalog';

export function PricingSection() {
  const { plans, loading, error } = usePlanCatalog();

  if (loading && plans.length === 0) {
    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-600">
          Loading pricing…
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-red-500">
          Failed to load pricing. Please try again later.
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Simple, Transparent Pricing
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className={`rounded-lg p-6 relative ${plan.popular ? 'border-2 border-purple-500' : 'border border-gray-200'}`}
              >
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-purple-500 text-white px-4 py-1 rounded-full text-sm">
                    Popular
                  </div>
                )}
                <h3 className="text-xl font-semibold mb-4">{plan.name}</h3>
                <p className="text-3xl font-bold mb-4">
                  ${plan.price}
                  <span className="text-lg font-normal text-gray-600">/month</span>
                </p>
                <ul className="text-sm text-gray-600 space-y-2 mb-6">
                  {plan.features.map((feature, index) => (
                    <li key={index}>• {feature}</li>
                  ))}
                </ul>
                {plan.price === 0 ? (
                  <Button className="w-full" variant="outline" asChild>
                    <a href="/signup">Get Started Free</a>
                  </Button>
                ) : (
                  <Button
                    className={plan.popular ? 'w-full bg-purple-500 hover:bg-purple-600' : 'w-full'}
                    variant={plan.popular ? 'default' : 'outline'}
                    asChild
                  >
                    <a href={`/payment?plan=${plan.id}&from=pricing`}>
                      {plan.id === 'pro-monthly' ? 'Upgrade to Pro' : 'Go Unlimited'}
                    </a>
                  </Button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
